import config from 'config'
import lang from '@/lang'

const urls = {
  single: 'letter',
  multiple: 'letters',
}

const resourceUrl = `${config.resourceHost}letter`

export default {
  resourceUrl,
  apiUrl: config.resourceHost,
  letterListSetting: `${config.resourceHost}setting/userlist/letter`,
  getNewLetter: `${resourceUrl}/new`,
  preview: `${resourceUrl}/preview`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
  ],
}
